// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".promote-signup-message[data-v-990329e6]{margin:0 auto;max-width:346px}.submit-error[data-v-990329e6]{color:#9081e6;margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
